export function prefixLocale(path: string, locale?: string): string {
  if (!locale) {
    return path;
  }
  const trimmed = locale.trim();
  if (trimmed.length === 0) {
    return path;
  }
  return `/${trimmed}${path}`;
}
